// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__6EAFl","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2itTP","obliqueLine":"membershipbadge_obliqueLine__3xeOn"};